import RemoveWidget from './RemoveWidget';

export default RemoveWidget;
